
/* Predictive product suggestions for the desktop header field. */
(() => {
  function initialise(root) {
    if (root.dataset.bonzaSearchReady === 'true') return;
    root.dataset.bonzaSearchReady = 'true';

    const input = root.querySelector('[data-bonza-search-input]');
    const results = root.querySelector('[data-bonza-search-results]');
    const searchUrl = root.querySelector('form').action;
    let timer;
    let controller;

    function closeResults() {
      results.hidden = true;
      results.replaceChildren();
      input.setAttribute('aria-expanded', 'false');
    }

    function showResults(products, term) {
      results.replaceChildren();

      if (products.length) {
        const heading = document.createElement('p');
        heading.className = 'bonza-desktop-search__heading';
        heading.textContent = 'Products';
        results.append(heading);

        const list = document.createElement('ul');
        list.className = 'bonza-desktop-search__list';

        products.forEach((product) => {
          const item = document.createElement('li');
          const link = document.createElement('a');
          link.className = 'bonza-desktop-search__link';
          link.href = product.url;
          link.textContent = product.title;
          item.append(link);
          list.append(item);
        });

        results.append(list);
      } else {
        const message = document.createElement('p');
        message.className = 'bonza-desktop-search__message';
        message.textContent = 'No matching treats. Try another search.';
        results.append(message);
      }

      const all = document.createElement('a');
      all.className = 'bonza-desktop-search__link bonza-desktop-search__all';
      const allUrl = new URL(searchUrl, window.location.origin);
      allUrl.searchParams.set('q', term);
      all.href = allUrl.toString();
      all.textContent = 'See all results for “' + term + '”';
      results.append(all);

      results.hidden = false;
      input.setAttribute('aria-expanded', 'true');
    }

    input.addEventListener('input', () => {
      clearTimeout(timer);
      if (controller) controller.abort();
      closeResults();

      const term = input.value.trim();
      if (term.length < 2) return;

      timer = window.setTimeout(async () => {
        controller = new AbortController();

        try {
          const localeRoot = window.Shopify?.routes?.root || '/';
          const url = new URL('search/suggest.json', window.location.origin + localeRoot);
          url.searchParams.set('q', term);
          url.searchParams.set('resources[type]', 'product');
          url.searchParams.set('resources[limit]', '6');

          const response = await fetch(url.toString(), {
            signal: controller.signal
          });
          if (!response.ok) throw new Error('Predictive search unavailable');

          const data = await response.json();
          if (input.value.trim() !== term) return;

          showResults(data.resources?.results?.products || [], term);
        } catch (error) {
          if (error.name !== 'AbortError') closeResults();
        }
      }, 200);
    });

    input.addEventListener('keydown', (event) => {
      if (event.key === 'Escape') closeResults();

      if (event.key === 'ArrowDown' && !results.hidden) {
        const firstLink = results.querySelector('a');
        if (firstLink) {
          event.preventDefault();
          firstLink.focus();
        }
      }
    });

    results.addEventListener('keydown', (event) => {
      if (event.key === 'Escape') {
        closeResults();
        input.focus();
      }
    });

    document.addEventListener('pointerdown', (event) => {
      if (!root.contains(event.target)) closeResults();
    });
  }

  function initialiseAll() {
    document.querySelectorAll('[data-bonza-desktop-search]').forEach(initialise);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initialiseAll);
  } else {
    initialiseAll();
  }

  document.addEventListener('shopify:section:load', initialiseAll);
})();
